export const dateTimeFormat = 'dd LLLL yyyy @ HH:mm';
export const dateFormat = 'dd LLLL yyyy';
export const creditUnit = 'ITMO';
